import { render, staticRenderFns } from "./WorkDialog.vue?vue&type=template&id=1c8df00a&scoped=true"
import script from "./WorkDialog.vue?vue&type=script&lang=ts"
export * from "./WorkDialog.vue?vue&type=script&lang=ts"
import style0 from "./WorkDialog.vue?vue&type=style&index=0&id=1c8df00a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c8df00a",
  null
  
)

export default component.exports